import "swiper/swiper-bundle.css";
import "../css/wfc_page.scss";
import "../js/wfc/wfc.js";
